import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";

const WhatsAppFAB: React.FC = () => {
  const phoneNumber = "7673937360"; 
  const message = "Hello! I’d like to know more about your services.";
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <Link
      to={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      className="
        fixed bottom-8 right-8 sm:bottom-12 
        bg-[#25D366] text-white
        rounded-full w-12 h-12
        flex items-center justify-center
        shadow-lg cursor-pointer
        hover:scale-110 hover:shadow-xl
        transition-transform duration-200 ease-in-out
        z-50
      "
    >
      <FaWhatsapp size={30} />
    </Link>
  );
};

export default WhatsAppFAB;
